// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z5gg","footer":"styles_footer__2jhfM"};